<template>
    <div class="app-actionSheet" v-if="isShow">
        <div class="app-actionSheet-list">
            <div class="app-actionSheet-btn" 
                v-for="(item, index) in itemList" 
                :key="index"
                @click="itemTap(index)"
                >{{item}}</div>
            <div class="app-actionSheet-btn cancel" @click="isShow = false">取消</div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            itemTap(index){
                this.isShow = false;
                this.onHide({index: index})
            }
        }
    }
</script>

<style scoped lang="scss">
    .app-actionSheet{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.7);
        z-index: 999999999;
        .app-actionSheet-list{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-radius: 0.2rem 0.2rem 0 0;
            background: #f3f3f3;
            font-size: 0.36rem;
            color: #343434;
            overflow: hidden;
            .app-actionSheet-btn{
                width: 100%;
                height: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                margin-top: 0.02rem;
                &:first-child{
                    margin-top: 0;
                }
                &.cancel{
                    margin-top: 0.1rem;
                }
            }
        }
    }
</style>